import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchFirstConsultationVersions } from '@/api/firstConsultations/firstConsultationSharingApi';
import type { FirstConsultationVersion } from '@/api/firstConsultations/firstConsultationSharingApi.types';
import { buildFirstConsultationVersionsQueryKey } from '@/constants/queryKeys';

export function useFirstConsultationVersionsQuery(
  consultationId: string
): UseQueryResult<FirstConsultationVersion[], Error> {
  return useQuery({
    queryKey: buildFirstConsultationVersionsQueryKey(consultationId),
    queryFn: function loadVersions() {
      return fetchFirstConsultationVersions(consultationId);
    },
    enabled: consultationId.length > 0,
  });
}
